module.exports = __webpack_public_path__ + "img/logo-catastro.f95e5a02.jpeg";